import React, { useEffect, useState, useContext } from "react"
import { Link } from "react-router-dom"
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Table,
  Button,
  Modal,
  Form,
  Input,
  Label,
  ModalHeader,
  FormFeedback,
  ModalBody,
  Badge,
} from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import Swal from "sweetalert2"
import Loading from "components/Loading"
import { HolidayApi } from "apis/HolidayApi"
import * as Yup from "yup"
import { useFormik } from "formik"
import { SessionContext } from "context/sessionContext"

const Holiday = () => {
  document.title = "Holiday "
  const { Session } = useContext(SessionContext)
  let session = Session || sessionStorage.getItem("SessionId")
  const [holidayList, setHolidayList] = useState([])
  const [isHoliday, SetIsHoliday] = useState()
  const [loader, setLoader] = useState()
  const [isEdit, setIsEdit] = useState(false)

  const getTodayDate = () => {
    const today = new Date()
    const year = today.getFullYear()
    const month = String(today.getMonth() + 1).padStart(2, "0")
    const day = String(today.getDate()).padStart(2, "0")
    return `${year}-${month}-${day}`
  }
  const todayDate = getTodayDate()

  const fetchHolidays = () => {
    const data = {
      session_id: session,
    }
    HolidayApi.getHoliday(data)
      .then(res => {
        if (res.data.status === 200) {
          setLoader("")
        }
        setHolidayList(res.data)
      })
      .catch(err => {
        console.log(err.message)
        setLoader("")
      })
  }

  useEffect(() => {
    if (
      !holidayList ||
      !holidayList.upcomming_holiday ||
      holidayList.upcomming_holiday.length === 0
    ) {
      setLoader(<Loading />)
    }
    fetchHolidays()
  }, [session])

  const onDelete = id => {
    let sid = {
      holiday_id: id,
    }
    Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#f46a6a",
      confirmButtonText: "Yes, delete it!",
    }).then(result => {
      if (result.isConfirmed) {
        HolidayApi.deleteHoliday(sid)
          .then(res => {
            Swal.fire("Deleted!", res.data.msg, "success")
            window.location.href = "/holiday"
          })
          .catch(err => {
            Swal.fire(
              "Error!",
              (err &&
                err.response &&
                err.response.data &&
                err.response.data.msg) ||
                err.message ||
                "Failed to delete",
              "error"
            )
          })
      }
    })
  }

  function convertDate(data) {
    if (!data) return "-"
    if (typeof data === "string" && data.includes("-")) {
      const parts = data.split("-")
      if (parts.length === 3) {
        const year = parseInt(parts[0], 10)
        const month = parseInt(parts[1], 10) - 1
        const day = parseInt(parts[2], 10)
        const date = new Date(year, month, day)
        if (!isNaN(date.getTime())) {
          return date.toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          })
        }
      }
    }
    const date = new Date(data)
    if (isNaN(date.getTime())) return "-"
    return date.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    })
  }

  const calculateDays = (fromDate, toDate, totalDays) => {
    if (totalDays !== undefined && totalDays !== null && totalDays !== "") {
      return totalDays
    }
    if (!fromDate) return 0
    if (!toDate || fromDate === toDate) return 1
    const from = new Date(fromDate)
    const to = new Date(toDate)
    if (isNaN(from.getTime()) || isNaN(to.getTime())) return 1
    const diffTime = Math.abs(to - from)
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1
    return diffDays > 0 ? diffDays : 1
  }

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      holiday_name: (isHoliday && isHoliday.holiday_name) || "",
      from_date: (isHoliday && isHoliday.from_date) || "",
      to_date: (isHoliday && isHoliday.to_date) || "",
      holiday_id: (isHoliday && isHoliday.id) || "",
      session_id: session,
    },
    validationSchema: Yup.object({
      holiday_name: Yup.string().required("Please Enter Your Holiday Name"),
      from_date: Yup.string()
        .required("Please Enter From Date")
        .test(
          "min-date",
          "From Date cannot be in the past",
          function (value) {
            if (!value) return true
            if (isEdit && isHoliday && isHoliday.from_date === value) {
              return true
            }
            return value >= todayDate
          }
        ),
      to_date: Yup.string()
        .required("Please Enter To Date")
        .test(
          "date-compare",
          "To Date cannot be before From Date",
          function (value) {
            const { from_date } = this.parent
            if (!from_date || !value) return true
            return new Date(value) >= new Date(from_date)
          }
        ),
    }),
    onSubmit: values => {
      const payload = {
        session_id:
          values.session_id || session || sessionStorage.getItem("SessionId"),
        holiday_id: values.holiday_id || "",
        holiday_name: values.holiday_name,
        from_date: values.from_date,
        to_date: values.to_date || values.from_date,
      }
      HolidayApi.createHoliday(payload)
        .then(res => {
          if (res.data.status === 200) {
            Swal.fire({
              text: res.data.msg,
              icon: "success",
              imageAlt: "success image",
            }).then(result => {
              if (result.isConfirmed) {
                window.location.href = "/holiday"
                toggle()
              }
            })
          } else {
            Swal.fire({
              text: res.data.msg || "Failed to save holiday",
              icon: "error",
              imageAlt: "error image",
            })
          }
        })
        .catch(err => {
          console.log(err.message)
          Swal.fire({
            text:
              (err &&
                err.response &&
                err.response.data &&
                err.response.data.msg) ||
              err.message ||
              "Something went wrong",
            icon: "error",
          })
        })
    },
  })

  const [modal, setModal] = useState(false)
  const toggle = () => {
    if (modal) {
      formClear()
      setModal(false)
    } else {
      setModal(true)
    }
  }
  const formClear = () => {
    SetIsHoliday(null)
    setIsEdit(false)
    validation.resetForm()
  }
  const handleProjectClick = () => {
    SetIsHoliday(null)
    setIsEdit(false)
    toggle()
  }
  const handleProjectEdit = arg => {
    let holiday = arg
    SetIsHoliday({
      id: holiday.id,
      holiday_name: holiday.holiday_name,
      from_date: holiday.from_date || holiday.holiday_date || "",
      to_date: holiday.to_date || holiday.from_date || holiday.holiday_date || "",
    })
    setIsEdit(true)
    toggle()
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Holiday" breadcrumbItem="Holiday List" />
          <Col xl="10" sm="12" className="mx-auto mb-4">
            <Row>
              <Col md={3} className=""></Col>
              <Col md={3} className=""></Col>
              <Col md={2}></Col>
              <Col md={4} className="">
                <Card className="bg-transparent shadow-none pt-0">
                  <CardBody className="p-0 text-end">
                    <Button
                      onClick={() => handleProjectClick()}
                      color="primary"
                      className="btn btn-primary waves-effect waves-light"
                    >
                      <i className="bx bxs-add-to-queue p-1"></i>
                      Add Holiday
                    </Button>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Col>
          <Col xl="10" sm="12" className="mx-auto mb-4">
            <Card>
              <CardBody>
                <Row>
                  {loader ? (
                    <div>{loader}</div>
                  ) : !holidayList ||
                    !holidayList.upcomming_holiday ||
                    holidayList.upcomming_holiday.length === 0 ? (
                    <Card className="shadow-none">
                      <div
                        style={{ height: "310px" }}
                        className="align-center text-center"
                      >
                        <h2 className="text-primary mt-5 ">
                          Holiday Not Found !
                        </h2>
                      </div>
                    </Card>
                  ) : (
                    <div className="table-responsive">
                      <Table className="table table-striped align-middle table-nowrap">
                        <thead>
                          <tr className="text-center table-secondary">
                            <th className="text-center" style={{ width: "70px" }}>
                              Sr No
                            </th>
                            <th className="text-start">Name</th>
                            <th>From Date</th>
                            <th>To Date</th>
                            <th>Total Days</th>
                            <th style={{ width: "100px" }}>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {holidayList &&
                            holidayList.upcomming_holiday &&
                            holidayList.upcomming_holiday.map(
                              (holiday, index, array) => {
                                const reversedIndex = array.length - 1 - index
                                const item = array[reversedIndex]
                                const fromDate =
                                  item.from_date || item.holiday_date
                                const toDate =
                                  item.to_date || item.from_date || item.holiday_date
                                const totalDays =
                                  item.total_days ||
                                  calculateDays(fromDate, toDate)

                                return (
                                  <tr key={item.id || index} className="text-center">
                                  <th scope="row" className="text-center">
                                    {index + 1}
                                  </th>
                                  <td className="text-start fw-medium">
                                    {item.holiday_name}
                                  </td>

                                  <td>{convertDate(fromDate)}</td>
                                  <td>{convertDate(toDate)}</td>

                                  <td>
                                    <Badge
                                      color="primary"
                                      className="font-size-12 px-2 py-1"
                                      pill
                                    >
                                      {totalDays}{" "}
                                      {totalDays > 1 ? "Days" : "Day"}
                                    </Badge>
                                  </td>

                                  <td>
                                    <div className="d-flex justify-content-center gap-3">
                                      <Link
                                        to="#"
                                        onClick={e => {
                                          e.preventDefault()
                                          handleProjectEdit(item)
                                        }}
                                        className="text-success"
                                      >
                                        <i
                                          className="mdi mdi-pencil font-size-18"
                                          id={`edittooltip-${item.id || index}`}
                                        />
                                      </Link>
                                      <Link
                                        to="#"
                                        className="text-danger"
                                        onClick={e => {
                                          e.preventDefault()
                                          onDelete(item.id)
                                        }}
                                      >
                                        <i
                                          className="mdi mdi-delete font-size-18"
                                          id={`deletetooltip-${item.id || index}`}
                                        />
                                      </Link>
                                    </div>
                                  </td>
                                </tr>
                              )
                            }
                          )}
                        </tbody>
                      </Table>
                    </div>
                  )}
                </Row>
              </CardBody>
            </Card>
            <div>
              <Modal isOpen={modal} toggle={toggle}>
                <ModalHeader toggle={toggle} tag="h4">
                  {isEdit ? "Update Holiday" : "Add Holiday"}
                </ModalHeader>
                <ModalBody>
                  <Form
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <Row>
                      <Col sm={12}>
                        <div className="mb-3">
                          <Label
                            htmlFor="holiday_name"
                            className="form-label my-control"
                          >
                            Name
                          </Label>
                          <Input
                            className="form-control"
                            id="holiday_name"
                            name="holiday_name"
                            type="text"
                            placeholder="Holiday Name"
                            onBlur={validation.handleBlur}
                            value={validation.values.holiday_name}
                            onChange={validation.handleChange}
                            invalid={
                              validation.touched.holiday_name &&
                              validation.errors.holiday_name
                                ? true
                                : false
                            }
                          />
                          {validation.touched.holiday_name &&
                          validation.errors.holiday_name ? (
                            <FormFeedback type="invalid">
                              {validation.errors.holiday_name}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="mb-3">
                          <Label
                            htmlFor="from_date"
                            className="form-label my-control"
                          >
                            From Date
                          </Label>
                          <Input
                            className="form-control"
                            id="from_date"
                            name="from_date"
                            type="date"
                            min={todayDate}
                            onBlur={validation.handleBlur}
                            value={validation.values.from_date}
                            onChange={e => {
                              validation.handleChange(e)
                              if (
                                !validation.values.to_date ||
                                validation.values.to_date < e.target.value
                              ) {
                                validation.setFieldValue("to_date", e.target.value)
                              }
                            }}
                            invalid={
                              validation.touched.from_date &&
                              validation.errors.from_date
                                ? true
                                : false
                            }
                          />
                          {validation.touched.from_date &&
                          validation.errors.from_date ? (
                            <FormFeedback type="invalid">
                              {validation.errors.from_date}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="mb-3">
                          <Label
                            htmlFor="to_date"
                            className="form-label my-control"
                          >
                            To Date
                          </Label>
                          <Input
                            className="form-control"
                            id="to_date"
                            name="to_date"
                            type="date"
                            min={validation.values.from_date || todayDate}
                            onBlur={validation.handleBlur}
                            value={validation.values.to_date}
                            onChange={validation.handleChange}
                            invalid={
                              validation.touched.to_date &&
                              validation.errors.to_date
                                ? true
                                : false
                            }
                          />
                          {validation.touched.to_date &&
                          validation.errors.to_date ? (
                            <FormFeedback type="invalid">
                              {validation.errors.to_date}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      {validation.values.from_date &&
                        validation.values.to_date && (
                          <Col sm={12}>
                            <div className="alert alert-info py-2 px-3 mb-2 font-size-13 d-flex align-items-center justify-content-between">
                              <span>
                                <i className="mdi mdi-calendar-clock me-1 font-size-15" />
                                Total Duration:
                              </span>
                              <span className="fw-bold">
                                {calculateDays(
                                  validation.values.from_date,
                                  validation.values.to_date
                                )}{" "}
                                {calculateDays(
                                  validation.values.from_date,
                                  validation.values.to_date
                                ) > 1
                                  ? "Days"
                                  : "Day"}
                              </span>
                            </div>
                          </Col>
                        )}
                    </Row>
                    <Row>
                      <Col>
                        <div className="text-end pt-3">
                          <Button
                            type="button"
                            color="secondary"
                            className="me-2"
                            onClick={toggle}
                          >
                            Cancel
                          </Button>
                          <button
                            type="submit"
                            className="btn btn-success save-user"
                          >
                            {isEdit ? "Update" : "Add"}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </ModalBody>
              </Modal>
            </div>
          </Col>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Holiday
